module.exports = __webpack_public_path__ + "img/Homered.e5b88ed0.svg";